import { combineReducers } from 'redux';
import * as types from './constants';

const initialState = {
    list: {
        table: {
            data: [],
            links: {},
            meta: {}
        }
    },
};

export default combineReducers({
    list(state = initialState.list, action) {
        switch (action.type) {
            case types.GET_MODULES_LIST_REQUEST:
                return { ...initialState.list, ...state };
            case types.GET_MODULES_LIST_FAILURE:
                // @todo:: handle universal error. add errors to form state if target object exists
                return null;
            case types.GET_MODULES_LIST_SUCCESS:
                return { ...state, table: action };
            default:
                return state;
        }
    },
});
